import leave from './leave'

export default {
    leave
}